import React from "react";
import Commitment from "components/Commitment/Commitment";
import PropType from "prop-types";
import { CommitmentsContainer } from "./Commitment.style";
//import useDevice from "hooks/useDevice";

const Commitments = ({ items, container }) => {
  return (
    <CommitmentsContainer $container={container}>
      {items?.map((commitment, index) => {
        return (
          <Commitment
            key={index}
            type={commitment.type}
            image={commitment.image}
            title={commitment.title}
            text={commitment.text}
            reverse={commitment.reverse}
            mobileInverted={commitment.mobileInverted}
            icon={commitment.icon}
            iconProperties={commitment.iconProperties}
            button={commitment.button}
            margin={commitment.margin}
            width={commitment.width}
          />
        );
      })}
    </CommitmentsContainer>
  );
};

Commitments.propTypes = {
  items: PropType.array,
  container: PropType.bool,
};

Commitments.defaultProps = {
  items: [],
  container: false,
};

export default Commitments;
